// @module Dev.ShoppingActions.ShoppingActionsModule
define('Dev.ShoppingActions.ShoppingActionsModule.View'
,	[
	'dev_shoppingactions_shoppingactionsmodule.tpl'
	
	,	'Dev.ShoppingActions.ShoppingActionsModule.Model'
	
	,	'Backbone'
	,	'jQuery'
    ]
, function (
	dev_shoppingactions_shoppingactionsmodule_tpl
	
	,	ShoppingActionsModuleModel
	
	,	Backbone
	,	JQuery
)
{
    'use strict';

	// @class Dev.ShoppingActions.ShoppingActionsModule.View @extends Backbone.View
	return Backbone.View.extend({

		template: dev_shoppingactions_shoppingactionsmodule_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new ShoppingActionsModuleModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
      		this.environment=options.env_comp;
		}

	,	events: {
			'click [data-action="calulate-weight"]': 'calculteWeight'
		}

	,	calculteWeight: function calculteWeight(e){
			// debugger;
			var current_url=window.location.href;
			var model=new ShoppingActionsModuleModel();
			JQuery('#weight-msg').text(' ');
			var width=Number(JQuery('[name=width_nbr]').val());
			var height=Number(JQuery('[name=height_nbr]').val());
			var thickness=Number(JQuery('[name=thickness]').val());

			var weight= Math.ceil(((width*height)/144)*(thickness));
			model.set({width: width});
			model.set({height: height});
			model.set({thickness: thickness});
			model.set({weight: weight});
			model.set({current_url: current_url});
			model.set({calculteWeight: true});
			JQuery('[name=weight-msg]').text('Your glass will weigh approximately '+weight+' pounds not including the packaging.');
			model.save().done(function(){
				console.log('ShoppingActionsModuleModel', ShoppingActionsModuleModel);
			});
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Dev.ShoppingActions.ShoppingActionsModule.View.Context
	,	getContext: function getContext()
		{
			return {
				
			}
		}
	});
});
